import { render, staticRenderFns } from "./OurAdvantages.vue?vue&type=template&id=30542278&scoped=true&"
import script from "./OurAdvantages.vue?vue&type=script&lang=js&"
export * from "./OurAdvantages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30542278",
  null
  
)

export default component.exports